import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, finalize, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure
} from './payment-arrangement.action';


import {
    fetchSingleRecord as fetchSingleRecordDossier,
} from '../Dossier/dossier.action';



import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RootReducerState } from '..';
import { Store } from '@ngrx/store';
import { RouterService } from 'src/app/core/services/router.service';
import { HelperService } from 'src/app/core/services/helper.service';


@Injectable()
export class PaymentArrangementRecordEffects {

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                
                const dossierId = data.dossierId;
                const url = `payment-arrangement/${dossierId}`;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        const data = response.data;
                        this.alertService.triggerAlert(response.message, "success");
                        return fetchSingleRecordSuccess({singleData: data.record});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = 'payment-arrangement/'+data.dossierId;
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.store.dispatch(fetchSingleRecordDossier({id: data.dossierId}));
                        this.store.dispatch(fetchSingleRecord({ dossierId: data.dossierId}));
                        this.alertService.triggerAlert(response.message, "success");
                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );
    
    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private store: Store<RootReducerState>,
        private routeService: RouterService,
        public helperService: HelperService
    ) { }

}